export const visit = (vm, at) => {
vm(require("./connect-inbox-render-modal/en.lyaml"));
at({ "en": { "htmlTitle": "HubSpot" } });
};